import { GlobalPassThrough } from 'primeng/config';
import { SelectTelekomPT } from './components/select';
import { BreadcrumbTelekomPT } from './components/breadcrumb';
import { ToggleSwitchTelekomPT } from './components/toggleswitch';
import { RadioButtonTelekomPT } from './components/radiobutton';
import { TooltipTelekomPT } from './components/tooltip';
import { DialogTelekomPT } from './components/dialog';
import { Translation } from '@ngx-translate/core';

export const telekomPassthrough = (tsKeys: Record<string, Translation>): GlobalPassThrough => ({
  select: SelectTelekomPT,
  breadcrumb: BreadcrumbTelekomPT(tsKeys),
  toggleSwitch: ToggleSwitchTelekomPT,
  radioButton: RadioButtonTelekomPT,
  tooltip: TooltipTelekomPT,
  dialog: DialogTelekomPT(tsKeys),
});
